import { FormProvider, useForm } from 'react-hook-form'
import { Outlet } from 'react-router'
import { AuthFormValue } from 'pages/auth/type'

const AuthLandingPage = () => {
  const methods = useForm<AuthFormValue>({
    defaultValues: {
      email: '',
      password: ''
    }
  })
  return (
    <>
      <FormProvider {...methods}>
        <Outlet />
      </FormProvider>
    </>
  )
}

export default AuthLandingPage
